import { render, staticRenderFns } from "./ProducerSpaces.vue?vue&type=template&id=416fc788&scoped=true&"
import script from "./ProducerSpaces.vue?vue&type=script&lang=js&"
export * from "./ProducerSpaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416fc788",
  null
  
)

export default component.exports